import React from "react";
import { ArrowButton } from "../../components/arrow-button";

interface SarahSareProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}

const SarahSare = (props: SarahSareProps) => {
    return (
        <div style={{ display: props.isVisible ? "block" : "none" }}>
            <article>
                <ArrowButton onClick={props.comeBackSemaSection} />
                <h4 className="section-title">
                    SARAH SARE<br />
                    (Vatikan Basın Danışmanı)
                </h4>

                <p className="text-bold">
                    İslam’la müşerref olan Sarah Sare’nin hidayet öyküsünü kendi ağzından dinleyelim:
                </p>

                <p>
                    Vatikan’da doğdum. Katolik bir anne babadan dünyaya geldim. Hıristiyan Katolik terbiyesi üzerine yetiştirildim. İslam’a tamamen zıt fikirlerle donatıldım. Buna kendim de razı değildim. Ailem ve hocalarımın teşvikiyle istemeyerek de olsa Hıristiyan gelenek içerisinde yaşamaya çalıştım. Üniversitede Gazetecilik ve Halkla İlişkiler bölümünü bitirdim. Şu anda da Vatikan’ın gazete ve dergilerini yayınlıyoruz. Aynı zamanda Vatikan’ın yayın danışmanlığını yapıyorum. Fakat Vatikan’ın içinde olmama rağmen din ve inanç sevgisinden uzaklaştım. Onun yerine içime değişik korkular gelmeye başladı. Vesveseler beni rahat bırakmadı.
                </p>
                <p>
                    Bir gün görevli olarak <span className="text-bold">İstanbul’</span>a gönderildim. Burada
                    Sultan Ahmet Camii’sini gezerken Edip Bey ile tanıştım. Oradaki Camii İmamının yanına giderek birkaç sorumun olduğunu söyledim.
                </p>

                <p>
                    Ancak Camii görevlisi bana müsait olmadığını söyledi. Bunun üzerine Edip Bey de “Bu akşam Nuredddin Cerrahi Tekkesinde zikir ve sema programı olacak dilerseniz siz de katılabilirsiniz.” diye sordu. Ben de memnuniyetle “Evet katılmak istiyorum.” dedim. Ardından İstanbul’da Karagümrük’teki Cerrahi Asitanesi’ne beni ve eşimi götürdü. Orada Sufilerle tanıştım. Sema ve zikir programını seyrettim. Şeyh Efendi ile gece saat 2’ye kadar görüştüm. Sorularımı sordum. Ancak orada sorularıma tatmin edici cevaplar alamadım. Ertesi gün Cuma günü Edip Bey bizi eşimle beraber Fatih’te bulunan Zaviyeye getirdi. Burada
                    Ali Yakub Baba ile tanıştım. Elimde kalın bir defter vardı. Sorularıma tatmin edici cevaplar verirseniz Müslüman olurum dedim. Ve şu soruları sordum. Sorularım 3 tane idi. İlk sorum şuydu:
                </p>

                <p className="text-italic">
                    “Papa John Paul’ün öldüğüne seviniyor musunuz?”
                </p>

                <p>
                    Ali Yakub Baba: “Hayır, Papa Müslüman bir insandı. Dünyada 2 milyar Müslüman var. Ve Müslümanların bir peygamberi olduğunu söylemiş. Peygamberini tasdik eden kim olursa olsun Müslümandır.“ diyerek cevapladı. İkinci sorum ise şöyle idi:
                </p>

                <p className="text-italic">
                    “İmamlar ve Sufiler neden anlaşamazlar?”
                </p>

                <p>
                    Ali Yakub Baba: “Aralarında eğitim farkı vardır. Onun için anlaşamazlar.” dedi. Ve son sorum şöyle idi:
                </p>

                <p className="text-italic">
                    “Peygamberler ve diğer insanlar arasında nasıl bir fark vardır?”
                </p>

                <p>
                    Ali Yakub Baba: “Yine eğitim farkı vardır. Peygamberleri eğiten, öğreten Allah’tır. Diğer insanları ise eğiten, öğreten ilim adamları ve mürşidlerdir.” diye cevapladı.
                </p>

                <p>
                    İşte o zaman sorularımın cevaplarını buldum ve teşekkür ettim.
                </p>

                <p>
                    <span className="text-bold">Hz. Mevlana’nın: “Gel, gel… Ne olursan ol yine gel. Yüz bin defa tövbeni bozmuş olsan da yine gel… Bizim dergâhımız ümitsizlik dergâhı değildir.” </span>çağrısı ile gönlümüze hidayet güneşinin nûrunun doğduğunu hissettim.
                </p>

                <p>
                    İçimde İslam’a karşı mükemmel bir sevgi oluştu. İçimdeki vesvese ve korkular tamamen çıkarıldı. Bu senaryolardan uzaklaşıp mutlu bir hayata döndüm.
                </p>

                <p>
                    Ali Yakub Baba ve Zaviyesindeki sufilerin namaz, zikir, sema ve sohbetlerine hayran kaldık.
                </p>

                <p>
                    Bunların neticesinde  <span className="text-bold">Amentü billahi ve melâiketihi,ve kütübihî ve rusülihî ve’l yevmi’lâhıri ve bi’l-kaderi, hayrihî ve şerrihi mina’llâhi teâlâ ve’l-ba’sü ba’de’l mevt. Hakkun, Eşhedü en lâ ilâhe illallâh ve eşhedü enne Muhammeden abdühû ve rasûlühü.” </span>“ deyip kelime-i şehadet getirerek İslam’la müşerref olduk.
                </p>

                <p className="text-bold">
                    İslam’ın esasları olan Kelime-i Şahadet, Namaz, Oruç, Zekât ve Hac bize talim buyruldu.
                </p>

                <p>
                    <span className="text-bold">Sare</span> ismini aldım.
                </p>

                <p>
                    Bundan sonra benim kalemim İslam için hizmet edecektir.
                </p>

                <p>
                    O sırada Yakub Baba, fotoğraf çekmek için balkona çıkan yanımdaki kişiyi sordu. Ben de “O benim eşimdir dedim. Ve o ateisttir. Dinlerle alakası yoktur.” dedim.
                </p>

                <p>
                    Ali Yakub Baba, eşimi yanına çağırarak şu soruyu sordu: “Sen ateistsin ama ateistliğin ne olduğunu bana anlatır mısın? Bilgin var mıdır”. Eşim de “Ateist ateistir. Anlatılacak bir şey yoktur.” dedi.
                </p>

                <p>
                    Ali Yakub Baba da: “Peki, sana bir şey sorsam cevaplar mısın?” dedi. Eşim de “Tabi” diyerek cevapladı. O anda çay içiyorduk.
                </p>

                <p>
                    Ali Yakub Baba: “Bu bardağın aslı nedir? Bu bardağın aslı topraktır veya taştır.  Daha sonra bu toprak bir ustanın elinden geçerek bardak oldu. Sonuç olarak usta, güzel ve estetik bir bardak yapmış. Ancak biz bu bardağın ustasını yani yapanını göremediğimiz hâlde bardağı yapanı inkâr mı edeceğiz?” diyerek soruyu eşime yöneltti.  Daha sonra sözlerine devam ederek: “Seni de beni de bunun gibi yaratan bir Allah vardır. Hatta seni de buraya kadar getiren Allah’tır. Kaderimizde bu yazılıdır."  O zaman eşim Radek, bir süre tefekkür etti. Ve daha sonra o da İslam ile müşerref oldu. Ve <span className="text-bold">Abdurrahman</span> ismini aldı.
                </p>

                <p>
                    Bunu müteakiben İstanbul’da bir hafta daha kaldık. Tekrar Zaviyede Ali Yakub Baba ile görüştük. Bu sefer daha muhtelif sohbetlerde bulunduk.
                </p>

                <p>
                    Kendilerine İncillerden pasajlar okudum. Onlar da bana İslam dinini ve güzelliklerini anlattılar.
                </p>

                <p>
                    Eski dindaşlarımın da bu nurlu yolda hidayet bulmalarını Allah’tan niyaz ediyorum.
                </p>

            </article>
        </div>
    );
}

export default SarahSare;